import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { canv } from "@/canv/global";
import { BottomBarItem } from "@/interface/BottomBar/BottomRightBar";
import styles from "./PresentationIsDeletedNotification.module.scss";

type TimedMessageProps = {
    text: string;
    duration?: number;
    cb?: () => void;
};

export const PresentationIsDeletedNotification = NiceModal.create(
    ({ text, duration = 30000, cb }: TimedMessageProps) => {
        const { t } = useTranslation();
        const modal = useModal();

        const handleClick = () => {
            canv.eventManager.Undo();
            cb?.();
            modal.remove();
        };

        useEffect(() => {
            const timer = setTimeout(() => {
                modal.remove();
            }, duration);

            return () => clearTimeout(timer);
        }, [duration, modal]);

        return (
            <div className={styles.notification}>
                <p>{text}</p>
                <BottomBarItem onClick={handleClick}>{t("common.cancel")}</BottomBarItem>
            </div>
        );
    },
);
